// Promise-based fade overlay. The DOM element lives in index.html.
// Use cycle() to bracket any work that should happen behind a black screen.

import { FADE_DURATION_MS } from '../app/config';

export class FadeTransition {
  private readonly el: HTMLElement;

  constructor() {
    const found = document.getElementById('fade-overlay');
    if (!found) throw new Error('[fade] #fade-overlay missing from DOM');
    this.el = found;
    // Sync CSS duration with config so JS waits don't drift from the visual.
    this.el.style.transitionDuration = `${FADE_DURATION_MS}ms`;
  }

  async out(durationMs: number = FADE_DURATION_MS): Promise<void> {
    this.el.classList.add('is-shown');
    await wait(durationMs);
  }

  async in(durationMs: number = FADE_DURATION_MS): Promise<void> {
    this.el.classList.remove('is-shown');
    await wait(durationMs);
  }

  async cycle<T>(work: () => Promise<T>, durationMs: number = FADE_DURATION_MS): Promise<T> {
    await this.out(durationMs);
    try {
      return await work();
    } finally {
      await this.in(durationMs);
    }
  }
}

function wait(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
